export const taskDropdownI18nPl = {
    enterTaskPlaceholder: "Wpisz zadanie",
    tasks: "Zadania",
};
